import { FC, useState } from 'react'
import ActiveLink from 'components/base/ActiveLink'
import cx from 'classnames'
import { logout, useUser } from 'common/services/useUser'
import Dropdown from 'components/base/forms/Dropdown'
import DropdownItem from 'components/base/forms/DropdownItem'
import { getStore } from 'common/store'
import { useRouter } from 'next/router'
import HMUpdates from 'hm-updates'
import Icon from 'project/Icon'
type ComponentType = {}

const Index: FC<ComponentType> = ({}) => {
  const [isActive, setIsActive] = useState<boolean>(false)
  const { data } = useUser({})
  const router = useRouter()
  return (
    <div className='container-fluid d-none d-md-flex justify-content-end align-items-center gap-5 pt-4 pb-0 mb-0'>
      <HMUpdates database={'23bfa0fe865280dfb526d047e1983991'} />
      <Dropdown
        dropdownClassName={'right'}
        dropdownContent={
          <>
            <div className=' text-center py-2 fs-sm '>
              <div className='fw-semibold'>
                {data?.first_name} {data?.last_name}
              </div>
              <div className='fs-xs text-muted px-3'>{data?.email}</div>
              <div className='fs-xss text-muted px-3'>{data?.partner_name}</div>
            </div>
            <hr className='my-0' />
            <DropdownItem
              className='fw-semibold'
              onClick={() => {
                router.push('/account')
              }}
            >
              <div className='d-flex gap-2 align-items-center'>
                <Icon fill='body' name={'settings'} /> Account Settings
              </div>
            </DropdownItem>
            <DropdownItem
              className='fw-semibold'
              onClick={() => {
                router.push('/')
                logout(getStore(), {})
              }}
            >
              <div className='d-flex gap-2 align-items-center'>
                <Icon fill='body' name={'logout'} /> Logout
              </div>
            </DropdownItem>
          </>
        }
        show={isActive}
        setShow={setIsActive}
      >
        <div
          onClick={() => setIsActive(!isActive)}
          className='d-none cursor-pointer d-md-flex justify-content-end align-items-center gap-3'
        >
          <span
            style={{ fontSize: 22 }}
            className='fa fa-user-circle  text-muted'
          />
        </div>
      </Dropdown>
    </div>
  )
}

export default Index
